import React from 'react';
import { Button, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { screeningCompletionItems, screeningContextSummary } from '../utils/screening';

const { Text } = Typography;

export default function ScreeningStatusPanel({ values, lastScreeningContext, onAskFollowUp, onRunScreening, loading }) {
  const items = screeningCompletionItems(values);
  const completeCount = items.filter((item) => item.done).length;
  const missingLabels = items
    .filter((item) => !item.done)
    .map((item) => (item.missing?.length ? `${item.label}: ${item.missing.join(', ')}` : item.label));
  const readyToScreen = missingLabels.length === 0;
  const progressPercent = Math.round((completeCount / items.length) * 100);

  return (
    <aside className="glp1-screener-status" aria-label="Screener status">
      <div className="glp1-status-header">
        <div>
          <Text strong>Checklist progress</Text>
          <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
            {completeCount} of {items.length} steps complete
          </Text>
        </div>
        <span className="glp1-status-count">{progressPercent}%</span>
      </div>

      <div className="glp1-status-progress" aria-hidden="true">
        <span style={{ width: `${progressPercent}%` }} />
      </div>

      <div className={`glp1-status-summary ${readyToScreen ? 'glp1-status-summary--ready' : ''}`}>
        {readyToScreen ? (
          <>
            <Text strong>Ready to screen</Text>
            <div>Run screening to save this as the latest Ask-mode context.</div>
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              loading={loading}
              onClick={onRunScreening}
              block
              className="glp1-status-primary-action"
            >
              Run screening
            </Button>
          </>
        ) : (
          <>
            <Text strong>Next missing fields</Text>
            <div>{missingLabels.join('; ')}</div>
          </>
        )}
      </div>

      <div className="glp1-status-list">
        {items.map((item, index) => (
          <div key={item.label} className="glp1-status-item">
            <span className={`glp1-status-marker ${item.done ? 'glp1-status-marker--done' : 'glp1-status-marker--missing'}`}>
              {item.done ? <CheckCircleOutlined /> : index + 1}
            </span>
            <span>
              <Text strong>{item.label}</Text>
              <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                {item.summary}
              </Text>
            </span>
          </div>
        ))}
      </div>

      {lastScreeningContext ? (
        <div className="glp1-status-summary glp1-status-latest">
          <Text strong>Latest result</Text>
          <div>{screeningContextSummary(lastScreeningContext)}</div>
          <Button size="small" style={{ marginTop: 8 }} onClick={onAskFollowUp}>
            Ask follow-up
          </Button>
        </div>
      ) : null}
    </aside>
  );
}
